/**
 * Number formatting for the dashboard's figures.
 *
 * The screen **computes nothing** — every value here already arrived from the API (ADR 0015 §3);
 * this only decides how many digits are shown. One decimal for a fraction, none for a whole
 * number, so a column of medians lines up under `tabular-nums`.
 *
 * `null` is not `0`. A metric with nothing to measure comes back as `null` on purpose — the
 * backend's *"null, never 0"* rule — and rendering it as a zero would put a number into the
 * reader's arithmetic that nobody measured. The caller passes the em dash it should read as.
 */
export function formatNumber(value: number | null | undefined, fallback: string): string {
  if (value === null || value === undefined) return fallback;
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}

/** The magnitude of a delta, without its sign — the arrow and the word carry the direction. */
export function formatDelta(delta: number, fallback: string): string {
  return formatNumber(Math.abs(delta), fallback);
}
